<template>
    <div class="panel">
        <div class="title qb-container">
          <h2>{{ title }}</h2>
        </div>
        <div class="panel-content">
          <!-- aqui entra o conteudo de dentro do panel -->
          <slot></slot>
        </div>
      </div>
</template>

<script>
export default {
    props: ['title'],
    data(){
        return{
            titleItem: 'title item'
        }
    }
}
</script>

<style scoped>

@media screen and (min-width: 900px) {

}

.panel{
  background-color: #fff;
  height: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 320px;
}

.panel-content{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  min-width: 308px;
  margin: 0 auto;
  min-height: 20vh;
}

</style>
